import { render, staticRenderFns } from "./CardPreview.vue?vue&type=template&id=5f8978f6"
import script from "./CardPreview.vue?vue&type=script&lang=js"
export * from "./CardPreview.vue?vue&type=script&lang=js"
import style0 from "./CardPreview.vue?vue&type=style&index=0&id=5f8978f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports